import React__default, { useCallback } from 'react';
import styles from './SelectionList.scss.mjs';
import { Section } from './components/Section/Section.mjs';

function SelectionList({
  sections,
  onActionAnySection
}) {
  const handleAction = useCallback(onActionAnyItem => {
    return event => {
      if (onActionAnyItem) {
        onActionAnyItem(event);
      }
      if (onActionAnySection) {
        onActionAnySection(event);
      }
    };
  }, [onActionAnySection]);
  const sectionsMarkup = sections.length > 0 ? sections.map(({
    items,
    title,
    onActionAnyItem,
    subtitle
  }, index) => /*#__PURE__*/React__default.createElement(Section
  // eslint-disable-next-line react/no-array-index-key
  , {
    key: `SelectionSection-${index}`,
    items: items,
    title: title,
    onActionAnyItem: handleAction(onActionAnyItem),
    subtitle: subtitle
  })) : null;
  return sectionsMarkup ? /*#__PURE__*/React__default.createElement("div", {
    className: styles.SelectionList
  }, sectionsMarkup) : null;
}

export { SelectionList };
